<link rel="stylesheet" [href]="cleanCssUrl" />

